$(function () {
    $('.quotes-slider').slick({
            dots: true,
            //infinite: false,
            speed: 1600,
            autoplay: true,
            autoplaySpeed: 2400,
        }
    );
    $('.products-slider').slick({
            dots: false,
            infinite: true,
            speed: 1200,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },

                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },

                },
            ]
        }
    );
    $('.product-slider').slick({
            dots: true,
            infinite: false,
            speed: 1200,
            autoplay: false,
        }
    );
    $('.products-category-slider').slick({
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 2,
            infinite: false,
            speed: 1200,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ]
            //autoplaySpeed: 4000,
        }
    );
});